export const navigateToViber = (phone: string) => {
  window.open(`viber://chat?number=${phone}`, "_blank");
};
